document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".faq__item");

  items.forEach((item) => {
    const button = item.querySelector(".faq__question");
    const answer = item.querySelector(".faq__answer");

    // Setup styles for animation
    answer.style.overflow = "hidden";
    answer.style.transition = "height 0.4s ease";

    // ✅ If already active (e.g., first one), set height to scrollHeight
    if (item.classList.contains("active")) {
      answer.style.height = answer.scrollHeight + "px";
    } else {
      answer.style.height = "0px";
    }

    button.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      // Collapse all
      items.forEach((i) => {
        i.classList.remove("active");
        const otherAnswer = i.querySelector(".faq__answer");
        otherAnswer.style.height = "0px";
      });

      // Expand clicked one if it wasn't already active
      if (!isActive) {
        item.classList.add("active");
        answer.style.height = answer.scrollHeight + "px";
      }
    });
  });
});
